import { deepFreeze } from '@dsee/util/objects.js';


export const productSearchFieldOptions = deepFreeze(
    {
        id: 'product',
        title: 'Продукт',
        nested: [
            {
                key: 'name',
                title: 'Название продукта',
                class: 'primary',
                disabled: true,
            },
            {
                key: 'description',
                title: 'Обзор продукта',
                class: 'primary',
                disabled: true,
            },
            {
                key: 'relevance',
                title: 'Актуальность',
                class: 'primary',
            },
            {
                key: 'features',
                title: 'Функции и возможности решения',
                class: 'primary',
            },
            {
                key: 'targetAudience',
                title: 'Целевая аудитория',
                class: 'primary',
            },
            {
                key: 'pricing',
                title: 'Ценообразование',
                class: 'primary',
            },
            {
                key: 'marketOverview',
                title: 'Обзор рынка',
                class: 'primary',
            },
            {
                key: 'transactionStages',
                title: 'Этапы сделки',
                class: 'primary',
            },
            {
                key: 'worksheet',
                title: 'Опросный лист',
                class: 'primary',
            },
            {
                key: 'salesScript',
                title: 'Скрипт продажи',
                class: 'primary',
            },
        ],
    },
);
export const pilotSearchFieldOptions = deepFreeze(
    {
        id: 'pilot',
        title: 'Проект',
        nested: [
            {
                key: 'name',
                title: 'Название проекта',
                class: 'secondary',
                disabled: true,
            },
            {
                key: 'description',
                title: 'Описание решения',
                class: 'secondary',
                disabled: true,
            },
            {
                key: 'problems',
                title: 'Бизнес-задачи проекта',
                class: 'secondary',
            },
            {
                key: 'effects',
                title: 'Полученные эффекты',
                class: 'secondary',
            },
        ],
    },
);
export const allSearchFieldOptions = [ ...productSearchFieldOptions.nested, ...pilotSearchFieldOptions.nested ];
export const productSearchFieldMap = productSearchFieldOptions.nested.filter(it => !it.disabled).map(it => it.key);
export const pilotSearchFieldMap = pilotSearchFieldOptions.nested.filter(it => !it.disabled).map(it => it.key);
